import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';


export function removeFromIdentityPoolOnSiteRequestConfig(siteUserLuid: string, poolId: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.18',
    httpMethod: 'DELETE',
    endpoint: `users/${siteUserLuid}/identityPool/${poolId}`,
    serverWideRequest: false
  };
}

export function callRemoveFromIdentityPoolOnSiteRequest(siteUserLuid: string, poolId: string): Promise<IResult> {
  return makeJsonRestApiRequest<void, IResult>({
    config: removeFromIdentityPoolOnSiteRequestConfig(siteUserLuid, poolId),
    request: null
  });
}
